import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EAuthRoutes } from '@agco-onedigital/ecosystem-lib-frontend-utils';
import { LoadingBar } from '@agco-onedigital/ecosystem-lib-web-components';
import { getUserData } from '../../service/graphql/user/getUserData';
import { useLaunchDarkly } from '../../store/LaunchDarkly';
import { handleLoginRedirect } from '../../utils/msalConfiguration/utils';
import getMsalInstance from '../../utils/msalConfiguration/msalInstance';

import { EPreAuthRoutes } from './types';

const AuthRouter = () => {
  const navigate = useNavigate();
  const launchDarkly = useLaunchDarkly();
  const location = useLocation();
  useEffect(() => {
    const init = async () => {
      const msalInstance = getMsalInstance(launchDarkly);
      await msalInstance.handleRedirectPromise();
      const account = msalInstance.getActiveAccount();
      if (!account) {
        void handleLoginRedirect(launchDarkly);
      } else {
        try {
          const userData = await getUserData(launchDarkly);
          if (userData) {
            navigate(EAuthRoutes.DASHBOARD, { replace: true });
          } else {
            navigate(EPreAuthRoutes.LOGIN_LOADING, { replace: true });
          }
        } catch (err) {
          // GraphQL NOT_FOUND during initial login → show loading screen
          navigate(EPreAuthRoutes.LOGIN_LOADING, { replace: true });
        }
      }
    };
    if (location.pathname !== EPreAuthRoutes.REGISTRATION && !process.env.JEST_WORKER_ID) {
      void init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, location]);

  return <LoadingBar />;
};

export default AuthRouter;
